import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const ModalUnlockBadge = ({ showModal, setShowModal, listBadges }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (showModal) {
      setCurrentIndex(0);
    }
  }, [showModal]);

  const handleNext = () => {
    if (currentIndex < listBadges.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const currentBadge = listBadges?.[currentIndex];
  if (!currentBadge) return null;

  return (
    <Dialog open={showModal} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 2,
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {currentBadge?.badgeName}
        </Typography>
        <Typography variant="body1">
          ¡Felicidades! Has desbloqueado esta insignia.
        </Typography>
        <Avatar
          sx={{
            width: 80,
            height: 80,
            mx: "auto",
            bgcolor: "grey.500",
          }}
        >
          <WorkspacePremiumIcon fontSize="large" />
        </Avatar>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "space-between",
          padding: 2,
        }}
      >
        {currentIndex !== 0 && (
          <Button
            variant="outlined"
            onClick={handlePrev}
            color="white"
            sx={{ color: "white" }}
          >
            Anterior
          </Button>
        )}
        {currentIndex === listBadges.length - 1 ? (
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ backgroundColor: "#e7ef7d" }}
          >
            Cerrar
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{ backgroundColor: "#e7ef7d" }}
          >
            Siguiente
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ModalUnlockBadge;
